(function () {
    'use strict';

    angular
        .module('searchModule')
        .controller('SearchBoxTriggerModalController', Controller);

    Controller.$inject = ['$scope', '$state'];

    function Controller($scope, $state) {

        // Search in new window
        $scope.searchInNewWindow = function () {
            var url = $state.href('search');
            window.open(url, '_blank');
            $scope.hideModal();
        };

        // Search in same window
        $scope.searchInSameWindow = function () {
            $state.go('search');
            $scope.hideModal();
        };
    }
})();